import React from 'react'
import { logUtil } from 'packages/src'

/**
 * @param onError
 * @param src
 * @param style
 * @param className
 * @param alt
 * @param isLazyLoading
 * @returns {JSX.Element}
 * @constructor
 */
export function ImageRawImg ({
  onError,
  src,
  style,
  className,
  isLazyLoading,
  alt
}) {
  const logPrefix = `src=${src}`
  const handleError = (err) => {
    logUtil('ImageRawImg#handleError').error(`${logPrefix} err=`, err)
    onError(err)
  }

  const props = {
    alt,
    style,
    className,
    onError: handleError
  }

  if (isLazyLoading) {
    props.dataSrc = src
  } else {
    props.src = src
  }

  return <img {...props} />
}
